import { render, staticRenderFns } from "./BoxesByPartnerFilter.vue?vue&type=template&id=610ee008&scoped=true&"
import script from "./BoxesByPartnerFilter.vue?vue&type=script&lang=js&"
export * from "./BoxesByPartnerFilter.vue?vue&type=script&lang=js&"
import style0 from "./BoxesByPartnerFilter.vue?vue&type=style&index=0&id=610ee008&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610ee008",
  null
  
)

export default component.exports